/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { formatDate } from '../../../../helpers/date-formatters';
import { formatNumber } from '../../../../helpers/number-formatters';

export const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 40vh;
  font-size: 12px;
`;

const TooltipContainer = styled.div`
  background-color: #fff;
  color: #111;
  border-radius: 2px;
  text-align: center;
  padding: 2px 6px;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  transform: translate(-50%, 0);
  white-space: nowrap;
`;

export const Dot = (props: any): JSX.Element => {
  const { cx, cy } = props;
  return (
    <g key={props.key}>
      <circle cx={cx} cy={cy} r={6} stroke="#FAD28C" strokeWidth={1} fill="transparent" />
      <circle cx={cx} cy={cy} r={3} strokeWidth={0} fill="#fff" />
    </g>
  );
};

export const ActiveDot = (props: any): JSX.Element => {
  const { cx, cy } = props;
  return (
    <circle key={props.key} cx={cx} cy={cy} r={6} stroke="#FAD28C" strokeWidth={5} fill="#fff" />
  );
};

export const CustomTooltip = (props: any): ReactElement<any, any> | null => {
  if (!props || !props.payload || !props.payload.length || !props.payload[0].value) {
    return null;
  }
  const value = props.payload[0]?.value;
  const date = props.payload[0]?.payload?.time;
  return (
    <TooltipContainer>
      <span className="text-10">{formatDate(date)}</span>
      <span className="text-10">
        <b>{formatNumber(value)}</b> HUF
      </span>
    </TooltipContainer>
  );
};
